import { StyledFlex } from "@lib/components/MiniComponents/Table/index.styled";
import { walletTypeColor } from "@lib/helpers/ColorHelper";
import { Tag } from "antd";
import { ColumnsType } from "antd/es/table";
import dayjs from "dayjs";
import { ApiParams, UseMutationProps } from "@lib/types/Api";
import { ColumnConfig, generateColumns } from "@lib/helpers/TableHelper";
import {
  ActionButton,
  TableIdButton,
} from "@lib/components/MiniComponents/Buttons";
import { TableColumnsProps } from "@lib/types/General";
import { ROUTES } from "@lib/constants";
import { CustomerName } from "@lib/components/MiniComponents/Others";
import { SendByteWallet, SendByteWalletType } from "@lib/types/SendByte";
import { WalletTypeIcon } from "@lib/components/MiniComponents/Icons";
import { StyledFlexDiv } from "@lib/components/StyledComponents";
import { getRoute } from "@lib/helpers/RouteHelper";

type Props<T> = TableColumnsProps<T> & {
  openModal: boolean;
  handleSelect: (wallet: T) => void;
  deleteQuery: UseMutationProps<T>;
  setParams?: (params: Partial<ApiParams>) => void;
  setFilter?: (filter: string) => void;
};

const getColumns = <T extends SendByteWallet>(
  props: Props<T>,
): ColumnsType<T> => {
  const {
    // context,
    detailContext,
    messages,
    handleSelect,
    deleteQuery,
  } = props;

  const columnsConfig: ColumnConfig<T>[] = [
    {
      title: "common.id",
      dataIndex: "id",
      filterType: "search",
      fixed: "left",
      render: (d) => <TableIdButton text={`#${d}`} textToBeCopied={d} />,
    },
    {
      title: "common.type",
      dataIndex: "type",
      width: "250px",

      render: (u, r) => (
        <StyledFlexDiv style={{ justifyContent: "flex-start" }}>
          <WalletTypeIcon type={r.type} sidebarCollapsed={false} />
          <Tag color={walletTypeColor(r?.type)}>
            {messages["walletType"][r?.type] as string}
          </Tag>
        </StyledFlexDiv>
      ),
      filterType: "dropdown",
      filters: Object.values(SendByteWalletType).map((item) => ({
        text: messages["walletType"][item],
        value: item,
      })),
    },
    {
      title: "common.name",
      dataIndex: "name",
      width: "180px",

      render: (d) => d,
    },
    {
      title: "common.customer",
      dataIndex: "customer",
      width: "180px",
      render: (v, r) => <CustomerName customer={r?.customer} link />,
      hidden: !!detailContext,
      // hiddenFor: [AppContext.CUSTOMER_LEAD],
    },

    {
      title: "common.createdAt",
      dataIndex: "createdAt",
      width: "180px",
      render: (d) => dayjs(d).format("DD/MM/YYYY"),
    },
    {
      title: "common.createdBy",
      dataIndex: "createdBy",
      width: "180px",
      filterType: "dropdown",
    },
    {
      title: "common.updatedAt",
      dataIndex: "updatedAt",
      width: "180px",
      render: (d) => dayjs(d).format("DD/MM/YYYY HH:mm"),
    },
    {
      title: "common.updatedBy",
      dataIndex: "updatedBy",
      width: "180px",
      filterType: "dropdown",
    },
    {
      title: "common.actions",
      dataIndex: "actions",
      className: "order-table-action",
      fixed: "right",
      width: "140px",
      render: (_, record) => (
        <StyledFlex className="actions">
          <ActionButton
            type="detail"
            noLabel
            href={getRoute(ROUTES.SEND_BYTE_WALLET_ACCOUNTS.WALLET_ID, {
              walletId: record.id,
            })}
          />

          <ActionButton
            type="edit"
            onClick={() => handleSelect(record)}
            noLabel
          />

          <ActionButton
            type="delete"
            onClick={() => deleteQuery.mutate(record)}
            itemName="common.walletAddress"
            noLabel
          />
        </StyledFlex>
      ),
    },
  ];

  return generateColumns(props, columnsConfig);
};
export default getColumns;
